import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class NonSalesService {

  constructor(private ws: PostmethodService) { }

  getNonSalesList(queryParams: any) {
    return this.ws.wsGet(environment.baseUrl + "/lead/leads?" + queryParams);
  }
}
